import { Button } from '@platform/components';
import {
  ApplicationResultContent,
} from '../../components/ApplicationResultContent';

export const ApplicationUnderReview = () => {
  return (
    <ApplicationResultContent
      title="What happens next?"
      description={
        <div>
          <p className='text-md -mt-6 mb-8'>We're excited you applied! Since this is a competitive program, it may take some time to get back to everyone, but we'll be in touch as soon as possible with next steps.</p>
          <Button variant='primary' size='lg' additionalClassnames='w-full' href='platform/'>
            Close
          </Button>
        </div>
      }
    />
  );
};
